/**
 * /superadmin/audit — the cross-tenant (platform) audit-log viewer.
 * Reuses the shared <AuditLogTable> in "platform" scope (its default
 * fetcher is the super-admin GET /api/v1/admin/audit-logs endpoint).
 * This is the existing platform surface, now reachable from the
 * Platform area's own nav instead of being an orphan.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AuditLogTable } from "@/components/superadmin/audit-log-table";
import { PageHeader } from "@/components/shared/page-header";

export const Route = createFileRoute("/_authgated/superadmin/audit")({
  component: PlatformAuditRoute,
});

function PlatformAuditRoute() {
  return (
    <>
      <PageHeader
        title="Audit Log"
        description="Every state change across all customer tenants."
      />
      <AuditLogTable scope="platform" />
    </>
  );
}
